// PN1 / DC-4, PIECE FOUR — **THE VISIBLE "NEW VERSION READY" AFFORDANCE.**
//
// Her order names this as one of the four that must ship with the worker, and the reason is the
// failure it prevents: a worker that takes over silently swaps the app out from under whoever is
// mid-sentence in Ask Lala. She is told, in a sentence with no machinery in it, and she chooses when.
//
// Props in, tree out, no hook and no fetch — so `scripts/pn1-service-worker.mjs` CALLS it and reads
// the tree back, including the copy, which comes from the shared law rather than being typed here.
import { UPDATE_COPY } from "../pwaUpdate.js";

export function UpdateBanner({
  open, onRefresh, onDismiss,
}: {
  open: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
}) {
  if (!open) return null;
  return (
    <div className="update-banner" role="status" aria-live="polite">
      <p className="update-banner__text">{UPDATE_COPY.title}</p>
      <span className="update-banner__acts">
        <button type="button" className="update-banner__go" onClick={onRefresh}>{UPDATE_COPY.action}</button>
        <button type="button" className="update-banner__later" onClick={onDismiss}>{UPDATE_COPY.dismiss}</button>
      </span>
    </div>
  );
}
